module.exports = __webpack_public_path__ + "fonts/text-security-disc.182464a7.eot";